/**
 * OrestBida Cookie Consent configuration
 *
 */


const baseCategories = {
    necessary: {
        enabled: true,
        readOnly: true,
    },
    analytics: {
        autoClear: {
            cookies: [{ name: /^_ga/ }, { name: '_gid' }],
        },
    },
    marketing: {
        autoClear: {
            cookies: [{ name: /^_gcl/ }, { name: '_fbp' }],
        },
    },
};


const translations = {
    nl: {
        consentModal: {
            title: 'Cookies op deze website',
            description: 'We gebruiken cookies om je ervaring te verbeteren, websiteverkeer te analyseren en voor advertentiepersonalisatie.  Door op "accepteren" te klikken ga je hiermee akkoord. <a class=\"cc-link\" href=\"/service/cookiebeleid/\">Ons cookiebeleid</a>.',
            acceptAllBtn: 'Accepteren',
            acceptNecessaryBtn: 'Afwijzen',
            showPreferencesBtn: 'Aanpassen',
        },
        preferencesModal: {
            title: 'Cookie voorkeuren',
            acceptAllBtn: 'Alles accepteren',
            acceptNecessaryBtn: null,
            savePreferencesBtn: 'Voorkeuren opslaan',
            closeIconLabel: 'Sluiten',
            sections: [
                {
                    title: null,
                    description: 'Wij gebruiken cookies om de basisfunctionaliteit te garanderen en om je online ervaring te verbeteren.',
                },
                {
                    title: 'Noodzakelijk',
                    description: 'Noodzakelijke cookies helpen een website bruikbaarder te maken, door basisfuncties als paginanavigatie en toegang tot beveiligde gedeelten van de website mogelijk te maken. Zonder deze cookies kan de website niet naar behoren werken.',
                    linkedCategory: 'necessary',
                },
                {
                    title: 'Statistieken',
                    description: 'Statistische cookies helpen ons begrijpen hoe bezoekers de website gebruiken, door anoniem gegevens te verzamelen en te rapporteren.',
                    linkedCategory: 'analytics',
                },
                {
                    title: 'Marketing',
                    description: 'Marketingcookies hebben als doel het personaliseren van de gebruikservaring en het tonen van relevante inhoud en aanbiedingen op deze en andere websites.',
                    linkedCategory: 'marketing',
                },
            ],
        },
    },
    de: {
        consentModal: {
            title: 'Cookies auf unserer Website',
            description: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, den Website-Traffic zu analysieren und Werbung zu personalisieren. Indem du auf "Akzeptieren“ klickst, erklärst du dich damit einverstanden. <a class=\"cc-link\" href=\"/service/cookies/\">Unsere Cookie-Richtlinie.</a>.',
            acceptAllBtn: 'Akzeptieren',
            acceptNecessaryBtn: 'Ablehnen',
            showPreferencesBtn: 'Anpassen',
        },
        preferencesModal: {
            title: 'Cookie-Einstellungen',
            acceptAllBtn: 'Alle akzeptieren',
            acceptNecessaryBtn: null,
            savePreferencesBtn: 'Einstellungen speichern',
            closeIconLabel: 'Schließen',
            sections: [
                {
                    title: null,
                    description: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, den Website-Traffic zu analysieren und personalisierte Inhalte bereitzustellen.',
                },
                {
                    title: "Erforderlich",
                    description: "Erforderliche Cookies helfen Websites dabei, nutzbar zu machen, indem grundlegende Funktionen wie Navigationsfunktionen und Zugang zu geschützten Teilen der Website ermöglicht werden. Ohne diese Cookies funktioniert die Website nicht ordnungsgemäß.",
                    linkedCategory: 'necessary',
                },
                {
                    title: "Statistiken",
                    description: "Statistische Cookies helfen Besitzern von Websites dabei, zu verstehen, wie Besucher ihre Website nutzen, indem anonyme Daten gesammelt und gemeldet werden.",
                    linkedCategory: "analytics"
                },
                {
                    title: "Marketing",
                    description: "Marketingcookies haben das Ziel, die Nutzererfahrung zu personalisieren und relevante Inhalte und Angebote auf dieser und anderen Websites anzuzeigen.",
                    linkedCategory: "marketing"
                },
            ],
        },
    },
    fr: {
        consentModal: {
            title: 'Nous utilisons des cookies',
            description: 'Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic sur notre site web et personnaliser les publicités. En cliquant sur «Accepter», vous acceptez ces conditions. <a class=\"cc-link\" href=\"/service/politique-de-cookies/\">En savoir plus sur les cookies</a>.',
            acceptAllBtn: 'Accepter',
            acceptNecessaryBtn: 'Rejeter',
            showPreferencesBtn: 'Modifier',
        },
        preferencesModal: {
            title: 'Préférences de cookies',
            acceptAllBtn: 'Tout accepter',
            acceptNecessaryBtn: null,
            savePreferencesBtn: 'Enregistrer les préférences',
            closeIconLabel: 'Fermer',
            sections: [
                {
                    title: null,
                    description: 'Nous utilisons des cookies pour garantir les fonctionnalités de base et améliorer votre expérience en ligne.',
                },
                {
                    title: 'Nécessaire',
                    description: 'Les cookies nécessaires contribuent à rendre un site web plus utilisable en permettant des fonctions de base telles que la navigation entre les pages et l\'accès aux zones sécurisées du site web. Sans ces cookies, le site web ne peut pas fonctionner correctement.',
                    linkedCategory: 'necessary',
                },
                {
                    title: 'Statistiques',
                    description: 'Les cookies statistiques nous aident à comprendre comment les visiteurs utilisent le site web, en collectant et en rapportant des données de manière anonyme.',
                    linkedCategory: 'analytics',
                },
                {
                    title: 'Marketing',
                    description: 'Les cookies marketing ont pour objectif de personnaliser l\'expérience utilisateur et d\'afficher du contenu et des offres pertinents sur ce site web et d\'autres sites web.',
                    linkedCategory: 'marketing',
                },
            ],
        },
    },
}

function getRootDomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Handle cases like .co.uk, .com.au, etc.
    if (parts.length > 2 && parts[parts.length - 2].length <= 3) {
        return parts.slice(-3).join('.');
    }

    return parts.slice(-2).join('.');
}

export function getConfig(lang) {
    return {
        cookie: {
            domain: "." + getRootDomain()
        },
        categories: baseCategories,
        language: {
            default: lang,
            translations: {
                [lang]: translations[lang],
            }
        },
        hideFromBots: true,
        disablePageInteraction: true,
        autoShow: !window.location.pathname.includes('cookies'),
        guiOptions: {
            consentModal: {
                layout: 'box wide',
                position: 'middle center',
                equalWeightButtons: false,
                flipButtons: false
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                flipButtons: true,
                equalWeightButtons: true,
            }
        },
    }
}
